import { render, staticRenderFns } from "./daoci.component.vue?vue&type=template&id=15c5a295"
import script from "./daoci.component.vue?vue&type=script&lang=js"
export * from "./daoci.component.vue?vue&type=script&lang=js"
import style0 from "./daoci.component.vue?vue&type=style&index=0&id=15c5a295&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports